import ReactGA from "react-ga4";

export function trackFilterChange(filterName: string, value: any) {
  ReactGA.event({
    category: "Filter",
    action: "Change Filter",
    label: filterName,
    value: typeof value === "string" ? undefined : value?.length || value,
  });
}

export function trackModalInteraction(
  action: "open" | "close",
  vcName: string
) {
  ReactGA.event({
    category: "Modal",
    action: `${action} Modal`,
    label: vcName,
  });
}

export function trackSearchTerm(term: string) {
  if (!term) return;
  ReactGA.event({
    category: "Search",
    action: "Search VCs",
    label: term,
  });
}

export function trackVCInteraction(vcName: string) {
  ReactGA.event({
    category: "VC Interaction",
    action: "View VC Details",
    label: vcName,
  });
}
